<template>
  <v-container fluid class="bg-image">
    <v-row>
      <v-btn @click="goBack" color="primary" class="text-capitalize" text>
        <v-icon>mdi-chevron-left</v-icon>{{$t('go_back')}}
      </v-btn>
    </v-row>
    <v-row justify="center">
      <v-img
        :src="imageLogoUrlBlue"
        max-height="150px"
        contain
        aspect-ratio="1.7"
      ></v-img>
    </v-row>
    <v-row justify="center">
      <v-col cols="12" md="8">
        <v-card class="transparent-card" flat>
          <v-card-title primary-title class="py-0 py-7">
            <v-row justify="center">
              <span class="text-h5 font-weight-light primary--text">TERMS & CONDITIONS</span>
            </v-row>
          </v-card-title>
          <v-card-subtitle class="font-weight-regular">
            <v-row justify="center">
              <span
                class="font-weight-medium subtitle-1 primary--text"
              >You must read and agree to the terms and conditions before registering</span>
            </v-row>
          </v-card-subtitle>
          <v-card-text>
            <v-row>
              <v-col cols="12">
                <terms-and-conditions-text />
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  components: {
    TermsAndConditionsText: () => import('@/components/TermsAndConditionsText')
  },
  methods: {
    goBack () {
      window.history.length > 0 ? this.$router.go(-1) : this.$router.push('/welcome')
    }
  }

}
</script>

<style lang="scss" scoped>
.bg-image {
  background: rgba($color: #f0f0f0, $alpha: 1);
}
.transparent-card {
  background: rgba(255, 255, 255, 0);
}
a {
  text-decoration: underline;
}
</style>
